import React, { useState, useEffect, useRef } from 'react';
import MuxPlayer from '@mux/mux-player-react';

const VideoPlayer = ({ playbackId, fill = false}) => {
  const [videoMetadata, setVideoMetadata] = useState({
    width: null,
    height: null,
    aspectRatio: null,
    duration: null,
    isLoaded: false
  });
  
  const playerRef = useRef(null);

  // Method 1: Listen to the player's metadata-loaded event
  const handleMetadataLoaded = (event) => {
    // Access the video element directly through the player
    const videoElement = playerRef.current?.mediaEl;
    
    if (videoElement) {
      const width = videoElement.videoWidth;
      const height = videoElement.videoHeight;
      const aspectRatio = width / height;
      const duration = videoElement.duration;
      
      setVideoMetadata({
        width,
        height,
        aspectRatio,
        duration,
        isLoaded: true
      });
      
    }
  };

  // Method 2: Fetch metadata from Mux API (requires backend implementation)
  // Note: This should typically be done on your server to protect your API keys
  useEffect(() => {
    if (playbackId) {
      // Example function - implement this on your backend
      const fetchVideoMetadata = async () => {
        try {
          // This is a placeholder for an API call to your backend
          const response = await fetch(`/api/videos/${playbackId}/metadata`);
          if (response.ok) {
            const data = await response.json();
            setVideoMetadata({
              width: data.width,
              height: data.height,
              aspectRatio: data.width / data.height,
              duration: data.duration,
              isLoaded: true
            });
          }
        } catch (error) {
          console.error('Error fetching video metadata:', error);
        }
      };
      
      fetchVideoMetadata();
    }
  }, [playbackId]);

  // Dynamic aspect ratio based on metadata (fallback to 16:9)
  const aspectRatioStyle = videoMetadata.aspectRatio 
    ? { aspectRatio: videoMetadata.aspectRatio } 
    : { aspectRatio: '16/9' };

  if (!playbackId) {
    return <div className="no-video-message">No video available</div>;
  }

  return (
    <div className="video-container">
      <div className="video-metadata">
        {videoMetadata.isLoaded && (
          <div className="metadata-details">
            <p>Resolution: {videoMetadata.width} × {videoMetadata.height}</p>
            <p>Aspect Ratio: {videoMetadata.aspectRatio?.toFixed(2) || 'Loading...'}</p>
            <p>Duration: {Math.floor(videoMetadata.duration / 60)}m {Math.floor(videoMetadata.duration % 60)}s</p>
          </div>
        )}
      </div>
      
			{fill ? (
				<MuxPlayer
					ref={playerRef}
					streamType="on-demand"
					playbackId={playbackId}
					onLoadedMetadata={handleMetadataLoaded}
					style={{
						height: '100%',
						width: '100%',
						position: 'absolute',
					}}
      	/>
			) : (
				<MuxPlayer
					ref={playerRef}
					streamType="on-demand"
					playbackId={playbackId}
					onLoadedMetadata={handleMetadataLoaded}
					style={{
						height: 'auto',
						maxWidth: '100%',
						width: '100%',
						...aspectRatioStyle,
					}}
				/>
			)}
      
    </div>
  );
};

export default VideoPlayer;